module.exports = __webpack_public_path__ + "static/media/TopMenu_Refresh.6b56a38e.svg";